
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiScreenSplitLeft as ObiScreenSplitLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-screen-split-left.js';
 
 
 

 
 export const ObiScreenSplitLeft = createComponent({
   react: React,
   tagName: 'obi-screen-split-left',
   elementClass: ObiScreenSplitLeftElement,
   events: {
     
   }
  });
 
 